import React from "react";


function Accommodation() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/accommodation2.png)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px'}}>
        <h3 style={{fontWeight:'600',fontSize:'15pt',lineHeight:'24pt',color:'maroon'}}>
            Accommodation facility will be <span style={{color:'red',fontSize:'18pt'}}>UNAVAILABLE</span>  in Panchajanyam Guest House, AC Dormitory, Non-AC Dormitory, Nelppura Hall from 15th Nov 2025 to 20th Jan 2026 due to the Murajapam Lakshadeepam Festival
        </h3>
        <hr />
        <h3 style={{marginBottom:'25px',fontWeight:'600'}}>Accommodation Facilities available for Devotees</h3>
        <div className="row">
            <div className="col-md-5" style={{background:'#fad096',padding:'50px'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-7 middle">
                        <p className="enquiry">For Enquiry & Booking</p>                                               
                    </div>
                    <div className="col-md-5 middle">
                        <p className="phone">0471 2472086</p>                                               
                    </div>                                        
                </div>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px'}}>
                    <h3 className="heading">Panchajanyam Guest House</h3>
                    {/* first */}
                    <div className="col-md-8 middle">
                        <p className="bed">Double Bed A/C Room</p>                                               
                    </div>
                    <div className="col-md-4 middle">
                        <p className="amount">Rs. 1904.00 </p>                                               
                    </div>   
                    {/* second */}
                    <div className="col-md-8 middle">
                        <p className="bed">Four Bed A/C Room</p>                                               
                    </div>
                    <div className="col-md-4 middle">
                        <p className="amount">Rs. 3360.00 </p>                                               
                    </div>    
                    {/* third */}
                    <div className="col-md-8 middle">
                        <p className="bed">Six Bed A/C Room</p>                                               
                    </div>
                    <div className="col-md-4 middle">
                        <p className="amount">Rs. 4144.00 </p>                                               
                    </div> 
                </div>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px'}}>
                    <h3 className="heading">Anandapadmanabha Nilayam (AC Dormitory)</h3>
                    {/* first */}
                    <div className="col-md-8 middle">
                        <p className="bed">Four Bed A/C Room</p>                                               
                    </div>
                    <div className="col-md-4 middle">
                        <p className="amount">Rs. 3920.00 </p>                                               
                    </div>   
                    {/* second */}
                    <div className="col-md-8 middle">
                        <p className="bed">Seven Bed A/C Room</p>                                               
                    </div>
                    <div className="col-md-4 middle">
                        <p className="amount">Rs. 5040.00 </p>                                               
                    </div>    
                    {/* third */}
                    <p style={{color:'black',fontWeight:'600'}}>(Room Rents are inclusive of GST)</p>
                </div>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px'}}>
                    <h3 className="heading"> Sreepadam Rest House (Non AC Dormitory)</h3>
                    {/* first */}
                    <div className="col-md-8 middle">
                        <p className="bed">Rs. 400.00/Person <br />(24 Hours)</p>                                               
                    </div>
                    <div className="col-md-4 middle">
                        <p className="amount">Single Bed </p>                                               
                    </div>   
                    {/* second */}
                    <div className="col-md-8 middle">
                        <p className="bed">Rs. 200.00/Person <br /> (12 Hours)</p>                                               
                    </div>
                    <div className="col-md-4 middle">
                        <p className="amount">Single Bed </p>                                               
                    </div>    
                    {/* third */}
                </div>
           </div> 
           <div className="col-md-7" style={{backgroundImage:'url(./images/event.jpeg)',backgroundSize:'cover',backgroundPosition:'center'}}></div>           
        </div>
        
        
      </div>
    </div>
  );
}

export default Accommodation;